import { Link, matchPath, useLocation } from "react-router-dom";
import { usePublicSite } from "@/contexts/PublicSiteContext";
import APropos from "@/pages/APropos";
import Accompagnements from "@/pages/Accompagnements";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import Home from "@/pages/Home";
import EmpreinteZenHome from "@/pages/EmpreinteZenHome";
import PrepMHome from "@/pages/PrepMHome";
import RendezVous from "@/pages/RendezVous";
import Sophrologie from "@/pages/Sophrologie";
import Tarifs from "@/pages/Tarifs";
import PlanEditorialPage from "@/components/PlanEditorialPage";

const TEMPLATES = {
  editorial_modules_v1: PlanEditorialPage,
  accueil_sophro_v1: Home,
  accueil_coaching_v1: Home,
  accueil_empreintezen_v1: EmpreinteZenHome,
  accueil_prepm_v1: PrepMHome,
  accompagnements_cards_v1: Accompagnements,
  sophrologie_editorial_v1: Sophrologie,
  coaching_method_v1: Sophrologie,
  catalogue_offres_v1: Tarifs,
  about_profile_v1: APropos,
  blog_index_v1: Blog,
  booking_public_v1: RendezVous,
  contact_form_v1: Contact,
};

export default function PlanPageRouter() {
  const location = useLocation();
  const { manifest, pageDocument, settings } = usePublicSite();

  const pages = manifest.pages || [];
  const page = pages.find(item => item.enabled !== false && item.route === location.pathname);
  if (page) {
    const source = page.aliasOf ? pages.find(item => item.id === page.aliasOf) : page;
    const Component = TEMPLATES[source?.template];
    return Component ? <><Component key={source.id} planPage={source} planManifest={manifest} initialPage={pageDocument} siteSettings={settings}/>{source.template !== "editorial_modules_v1" && pageDocument?.content?.layout_json && <PlanEditorialPage key={`${source.id}-editorial`} embedded planPage={source} planManifest={manifest} initialPage={pageDocument}/>}</> : <PlanMessage title="Gabarit indisponible" text={`Le gabarit ${source?.template || "inconnu"} n'est pas installe.`}/>;
  }

  const articleTemplate = (manifest.dynamic_templates || []).find(item => item.source === "articles" && matchPath(item.route, location.pathname));
  if (articleTemplate) return <BlogArticle/>;
  return <PlanMessage title="Page introuvable" text="Cette page n'appartient pas au Plan actuellement affiche."/>;
}

function PlanMessage({ title, text }) {
  return <section className="flex min-h-[65vh] items-center bg-bone-light px-6 pt-20"><div className="mx-auto max-w-xl text-center"><p className="font-playfair text-4xl text-charcoal">{title}</p><p className="mt-4 font-manrope text-charcoal-muted">{text}</p><Link to="/" className="btn-primary mt-8 inline-flex">Revenir a l'accueil</Link></div></section>;
}
